import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgOpenIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M11.0059 1.0625L17.0006 1.0625L17.0006 7.05721",
			stroke: "white",
			strokeWidth: 1.22519,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M6.99414 16.9375L0.999435 16.9375L0.999435 10.9428",
			stroke: "white",
			strokeWidth: 1.22519,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16.833 1.16704L10.4746 7.52539",
			stroke: "white",
			strokeWidth: 1.22519,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M1.16704 16.831L7.52539 10.4727",
			stroke: "white",
			strokeWidth: 1.22519,
			strokeLinecap: "round"
		})
	]
});
export default SvgOpenIcon;
